<template>
  <div>
    <div class="card-header border-0 bg-transparent">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">{{title}}</h3>
        </div>
        <div class="col text-right">
          <slot name="header-right">
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "datatable-header",
  props: {
    title: String,
  }
};
</script>
